<script lang="ts">
	import { API_URL_DEFAULT, TRADE_STATS_API_URL_DEFAULT } from '$lib/apis/constants';
	import { apiURL, tradeStatsApiURL } from '$lib/apis/store';
	import { clickOutside } from '$lib/util/directives/clickOutside';
	import { quadInOut } from 'svelte/easing';
	import { scale } from 'svelte/transition';

	let showDropDown: boolean = false;
	const ignoreElement: string = '#IgnoreElement';
	const apis = [
		{
			name: 'Perps',
			api: `${$apiURL}`,
			actual: API_URL_DEFAULT,
			modified: $apiURL !== API_URL_DEFAULT
		},
		{
			name: 'Trade Stats',
			api: `${$tradeStatsApiURL}`,
			actual: TRADE_STATS_API_URL_DEFAULT,
			modified: $tradeStatsApiURL !== TRADE_STATS_API_URL_DEFAULT
		}
	];
</script>

{#if showDropDown}
	<div
		class="modal absolute right-[40px] top-16 flex justify-end z-10 rounded-lg w-96 border-fx-grey-600"
		id="IgnoreElement"
		transition:scale|global={{
			duration: 100,
			delay: 0,
			opacity: 0.9,
			start: 0.97,
			easing: quadInOut
		}}
	>
		<img src="scwallet/copy.png" class="w-4 h-4" alt="copy" />
		<div
			class="flex flex-col w-full absolute duration-500 rounded-lg squircle-lg bg-fx-gradient-8 justify-between p-2"
		>
			{#each apis as api}
				<div class="flex items-center gap-1">
					<div>
						{api.modified ? '🟢' : '🔴'}
					</div>
					<div class="flex justify-between w-full">
						<div class="text-fx-white text-xs">{api.name}</div>
						<div class="text-fx-white text-xs">{api.modified ? api.api : api.actual}</div>
					</div>
				</div>
			{/each}
		</div>
	</div>
{/if}
<div class="sm:flex gap-3">
	{#if $apiURL !== API_URL_DEFAULT || $tradeStatsApiURL !== TRADE_STATS_API_URL_DEFAULT}
		<button
			class="border border-fx-grey-600 bg-fx-white px-2 pt-2 pb-1 rounded-lg squircle-lg text-fx-grey-900 text-sm flex gap-1 font-semibold"
			on:click={() => (showDropDown = !showDropDown)}
			use:clickOutside={ignoreElement}
			on:outclick={() => (showDropDown = false)}
		>
			⛭
		</button>
	{/if}
</div>
